import { HttpTransportErrorCode } from '@goodt-common/net';
import { ApiHttpClientError } from './errors/ApiClientError';
/**
 *
 * @type {Readonly<{}>}
 */
export const HttpTransportToApiClientErrorCodeMap = Object.freeze({
    [HttpTransportErrorCode.INTERNAL]: ApiHttpClientError.Code.INTERNAL,
    [HttpTransportErrorCode.BAD_REQUEST]: ApiHttpClientError.Code.BAD_REQUEST,
    [HttpTransportErrorCode.FORBIDDEN]: ApiHttpClientError.Code.FORBIDDEN,
    [HttpTransportErrorCode.NOT_FOUND]: ApiHttpClientError.Code.NOT_FOUND,
    [HttpTransportErrorCode.UNAUTHORIZED]: ApiHttpClientError.Code.UNAUTHORIZED,
    [HttpTransportErrorCode.INTERNAL_SERVER_ERROR]: ApiHttpClientError.Code.INTERNAL_SERVER_ERROR,
    [HttpTransportErrorCode.CONFLICT]: ApiHttpClientError.Code.CONFLICT
});

export const ApiClientMethod = Object.freeze({
    GET: 'get',
    POST: 'post',
    PATCH: 'patch',
    PUT: 'put',
    DELETE: 'delete'
});
